import classNames from 'classnames';
import { ReactNode, useEffect, useRef, useState } from 'react';
import './style.scss';

interface Props {
  className?: string;
  isOpened?: boolean;
  children?: ReactNode;
}

/**
 * Collapse Component
 *
 * @param {Props} { isOpened, className, children }
 * @return {*}
 */
const Collapse = ({ isOpened, className, children }: Props) => {
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  // Set height if isOpened
  // If opened set scroll height or 0
  useEffect(() => {
    if (contentRef.current) setHeight(isOpened ? contentRef.current.scrollHeight : 0);
  }, [isOpened, contentRef]);

  return (
    <div className={classNames('collapse', className, { opened: isOpened })}>
      {/* Content */}
      <div ref={contentRef} className="collapse-content" style={{ height }}>
        {children}
      </div>
    </div>
  );
};

export default Collapse;
